import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { NotificationType } from './notification.types';
import { getParametersFromUrl } from '../../utils/url-utils/urlUtils';

export function sendNotificationClickedEvent() {
  doctrineAnalytics('Notification ItemClicked');
}

export function getNotificationTrackingParameters(
  notification: NotificationType,
) {
  return getParametersFromUrl(notification.link).source
    ? {
        source_notification_id: notification.id,
      }
    : {
        source_notification_id: notification.id,
        source: 'notifications-list',
      };
}
